import type { IconNode } from '../types';

/**
 * @name door-stairwell
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTd2LTNhMSAxIDAgMDExLTFoNiIgLz4KICA8cGF0aCBkPSJNMTkgMTdoLTlhMSAxIDAgMDAtMSAxdjMiIC8+CiAgPHBhdGggZD0iTTE5IDIxVjVhMiAyIDAgMDAtMi0ySDdhMiAyIDAgMDAtMiAydjE2IiAvPgogIDxwYXRoIGQ9Ik0xOSA5aC0zYTEgMSAwIDAwLTEgMXYzIiAvPgogIDxwYXRoIGQ9Ik0yMiAyMUgyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/door-stairwell
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const DoorStairwell: IconNode = [
  ['path', { d: 'M12 17v-3a1 1 0 011-1h6' }],
  ['path', { d: 'M19 17h-9a1 1 0 00-1 1v3' }],
  ['path', { d: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16' }],
  ['path', { d: 'M19 9h-3a1 1 0 00-1 1v3' }],
  ['path', { d: 'M22 21H2' }],
];

export default DoorStairwell;
